import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { filter, of, switchMap, take } from 'rxjs';
import * as fromAssistants from '../assistants';
import { teammatesFeature } from './store';
import { TeammatesActions } from './store/teammates.actions';

export const teammatesResolver = () => {
  const store = inject(Store);
  const translateService = inject(TranslateService);

  if (store.selectSignal(teammatesFeature.selectLoaded)()) {
    return of(store.selectSignal(teammatesFeature.selectAllWithAssistants)());
  }

  return store.select(fromAssistants.assistantsFeature.selectLoaded).pipe(
    filter((loaded) => loaded),
    take(1),
    switchMap(() => {
      store.dispatch(
        TeammatesActions.loadTeammates({
          locale: translateService.getCurrentLang() as 'en' | 'fr',
        }),
      );
      return store.select(teammatesFeature.selectLoaded).pipe(
        filter((loaded) => loaded),
        take(1),
        switchMap(() => store.select(teammatesFeature.selectAllWithAssistants)),
      );
    }),
  );
};
